<div class="error-popup">
  <div class="h1 margin-card" translate="error.title"></div>
  <div class="margin-card error-popup__image-box">
    <img class="error-popup__image" src="./assets/img/icons/i-tools.svg" alt="Gears image" width="145" height="145">
  </div>
  @if (hasToken) {
    <p class="margin-card" translate="error.message.description"></p>
    <div class="actions-wrapper actions-wrapper--popup">
      <btn buttonText="error.label.copy-error" (action)="copy(); tooltipOnClick.show()"></btn>
      <span #tooltipOnClick="matTooltip" [matTooltip]="'error.message.copied' | translate"
            matTooltipPosition="above"
            matTooltipHideDelay="1500"
            class="tooltip-message"
            matTooltipClass="tooltip-message"></span>
      <btn [link]="true" buttonText="error.label.back" (action)="close()"></btn>
    </div>
  } @else {
    <p class="margin-card" translate="error.message.description-no-token"></p>
    <div class="actions-wrapper actions-wrapper--popup">
      <button class="button" translate="error.label.got-it" (click)="close()"></button>
    </div>
  }
</div>

<div #container class="stash"></div>
